import { AddressForm, BackButton, Form, FormInput, FormTextArea, Label, useAlignments } from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialInsured = (props) => {
    const alignments = useAlignments();
    const [mode] = useState('insuredView');

    const changeAddress = (dotProp, value) => {
        if (dotProp === 'address') {
            props.doReducePolicyElement({ code: `${props.dotProp}address`, value });
        } else {
            props.doReducePolicyElement({ code: `${props.dotProp}address.${dotProp}`, value });
        }
    };

    const saveAddressHandler = () => {
        props.doUpsertPolicy();
    };

    return (
        mode === 'insuredView' && (
            <React.Fragment>
                <BackButton clickEvent={props.backEvent} />
                <Form
                    rowId={props.rowId}
                    sectionCode='additionalInsuredDetails'
                    pageCode={props.pageCode}
                    saveTooltipInfo={props.saveTooltipInfo}
                    reduceTooltipInfoElement={props.reduceTooltipInfoElement}
                    tooltipInfo={props.tooltipInfo}
                    validationInfo={props.validationInfo}
                    header={
                        <FormattedMessage
                            id={props.additionalInsured?.label}
                            defaultMessage={props.additionalInsured?.label}
                        />
                    }
                    label={
                        <FormattedMessage id='Profile_SupernovaCommercial_Insureds_Insured.additionalInsuredDetails' />
                    }
                    allowEdit={props.allowEdit}
                    saveEvent={() => props.doUpsertPolicy()}
                    cancelEvent={() => props.doGetPolicy()}
                >
                    <FormInput
                        fieldCode='legalBusinessName'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_Insureds_Insured.businessName' />}
                        value={props.additionalInsured?.legalBusinessName}
                        type='text'
                        changeEvent={(value) =>
                            props.doReducePolicyElement({ code: `${props.dotProp}legalBusinessName`, value })
                        }
                        allowEdit
                    />
                    <Label
                        bold
                        text={<FormattedMessage id='Profile_SupernovaCommercial_Insureds_Insured.reasonRequired' />}
                        textAlign={alignments.left}
                    />
                    <FormTextArea
                        fieldCode='note'
                        text={props.additionalInsured?.note}
                        changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}note`, value })}
                        allowEdit
                    />
                </Form>
                <AddressForm
                    {...props}
                    enableAddressSearch
                    pageCode={props.pageCode}
                    sectionCode='additionalInsuredAddressDetails'
                    saveTooltipInfo={() => props.doUpsertTooltipInfo(props.policy.product)}
                    reduceTooltipInfoElement={props.doReduceTooltipInfoElement}
                    tooltipInfo={props.tooltipInfo}
                    validationInfo={props.validationInfo}
                    addressSearchCountryCode='CAN'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_Insureds_Insured.addressDetails' />}
                    label={<FormattedMessage id='Profile_SupernovaCommercial_Insureds_Insured.locationDetails' />}
                    saveEvent={saveAddressHandler}
                    cancelEvent={props.doGetPolicy}
                    reference={props.reference}
                    changeEvent={(dotProp, value) => changeAddress(dotProp, value)}
                    allowEdit={props.allowEdit}
                    address={props.additionalInsured?.address}
                />
            </React.Fragment>
        )
    );
};

export default ProfileSupernovaCommercialInsured;
